import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';

const useStyles = makeStyles(() => ({
  Container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'stretch',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  Label: {
    color: '#fdfdfe',
    fontSize: '16px',
    lineHeight: '1',
    fontWeight: 'normal',
    wordWrap: 'break-word',
    minWidth: 0,
    padding: '10px 20px',
  },
  pickerValue: {
    color: '#FFFFFF99',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '16px',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '91px',
  },
  styledPickerWrapper: {
    backgroundColor: '#ACACAC1A',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    '& .picker-item': {
      transition: 'all 0.3s ease',
      transform: 'scale(0.8) rotateX(20deg)',
      transformOrigin: 'center',
      fontSize: '16px',
      fontWeight: 500,
      fontFamily: 'Roboto',
      color: '#FFFFFF99',
    },
    '& .picker-item.picker-item-selected': {
      transform: 'scale(1) rotateX(0deg)',
      opacity: 1,
      color: 'white !important',
    },
    '& .picker-highlight': {
      backgroundColor: '#FFFFFF2E',
      width: '315px',
      margin: '0 auto',
      left: 'auto',
      right: 'auto',
      borderRadius: '6px',
      '&::before': {
        display: 'none !important',
      },
      '&::after': {
        display: 'none !important',
      },
    },
  },
  TopRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '43px',
  },
  dropdownArrow: {
    color: '#FFFFFF99',
    fontSize: '24px',
    marginLeft: '4px',
    textAlign: 'right',
  },
  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '10px',
  },
}));

export const Container = (props) => {
  const classes = useStyles();
  return <Box className={classes.Container} {...props} />;
};

export const Label = (props) => {
  const classes = useStyles();
  return <Typography className={classes.Label} {...props} />;
};

export const PickerValue = (props) => {
  const classes = useStyles();
  return <Box className={classes.pickerValue} {...props} />;
};

export const StyledPickerWrapper = (props) => {
  const classes = useStyles();
  return <Box className={classes.styledPickerWrapper} {...props} />;
};

export const TopRow = (props) => {
  const classes = useStyles();
  return <Box className={classes.TopRow} {...props} />;
};

export const DropdownArrow = (props) => {
  const classes = useStyles();
  return <KeyboardArrowDown className={classes.dropdownArrow} {...props} />;
};

export const ActionContainer = (props) => {
  const classes = useStyles();
  return <Box className={classes.actionContainer} {...props} />;
};
